import styled from 'styled-components';
import { heading4, textColors, colors, spacing, letterSpacing, fontSizes } from 'ui/theme';
import { Link } from 'ui/links';
import { ListEmptyTableState } from 'ui/illustrations';

const displayContent = {
  label: 'No lists yet',
  information: 'Learn more by visiting our ',
  link: 'Knowledge Center',
};

const ListContainer = styled.div`
  background-color: ${colors.white};
  grid-column: 1 / span 2;
  padding: ${spacing.x4} 0;
  margin: ${spacing.x3};
  justify-self: center;
  text-align: center;
  letter-spacing: ${letterSpacing.pos10};

  > * {
    padding-bottom: ${spacing.half};
  }
`;

const Label = styled.div`
  ${heading4};
`;

const Description = styled.span`
  color: ${textColors.textSecondary};
  font-size: ${fontSizes.s16};
`;

export const EmptyTableState = () => {
  const LIST_KNOWELDGE_BASE_URL =
    'https://support.iterable.com/hc/en-us/articles/218365803-User-Profile-Overview-#list-membership-tab';

  return (
    <ListContainer data-test="empty-table-state">
      <ListEmptyTableState />
      <Label data-test="empty-table-label">{displayContent.label}</Label>
      <Description data-test="empty-table-description">
        {displayContent.information}
        <Link hasOpenNewTabIcon href={LIST_KNOWELDGE_BASE_URL} target="_blank">
          {displayContent.link}
        </Link>
      </Description>
    </ListContainer>
  );
};
